// client/src/modules/explorer/nav.ts
import type { NavItem } from '../types';

/**
 * Central Command module navigation
 *
 * Dashboards — KPI views grouped under one dropdown
 * Data Health — infrastructure health with sub-page links
 * Data Browser — raw collection explorer
 */
export const navItems: NavItem[] = [
  {
    label: 'Dashboards',
    path: '/command',
    children: [
      { label: 'Executive', path: '/command' },
      { label: 'Operations', path: '/command/operations' },
      { label: 'Sales', path: '/command/sales' },
      { label: 'Fleet & Assets', path: '/command/fleet' },
    ],
  },
  {
    label: 'Data Health',
    path: '/command/health',
    children: [
      { label: 'System Health', path: '/command/health?tab=health' },
      { label: 'Connections', path: '/command/health?tab=connections' },
      { label: 'Sync Logs', path: '/command/health?tab=sync' },
      { label: 'Errors', path: '/command/health?tab=errors' },
      { label: 'Collection Health', path: '/command/health?tab=collection-health' },
      { label: 'Knowledge Gaps', path: '/command/health?tab=knowledge-gaps' },
      { label: 'Anomalies', path: '/command/health?tab=anomalies' },
    ],
  },
  { label: 'Data Browser', path: '/command/data' },
];
